import React, { useState, useEffect, useRef } from "react";
import {MegamenuFeaturedImages} from "../../MegamenuFeaturedImages/MegamenuFeaturedImages";
import {MegamenuLinks} from "../../MegamenuLinks/MegamenuLinks";
import useMegamenu from "../../hooks/useMegamenu";
import {MegamenuOverlay} from "../../MegamenuOverlay/MegamenuOverlay";
import useHeaderMenuStore from "@src/stores/HeaderMenuStore";
import { useHeaderHeight } from '@src/hooks/useHeaderHeight';

export const Sidebar = ({
    settings,
    menuItems,
    id,
    layout,
    state
}) => {
    // console.log('settings', settings.section);
    const megamenuRef: any = React.useRef(null); // Reference to the popup container
    const megamenuSM = useMegamenu(megamenuRef, menuItems, settings, false);
    const featuredFlexBasis = 30;

    const block = settings.blocks.find(
        (block) => block.type === "images",
    );

    const featuredBlockWidth = block?.settings?.block_width;
    const featureBlockMeasurement = block?.settings?.width_measurement;
    const featuredBlockWidthClass = featureBlockMeasurement === "%" && featuredBlockWidth > 0
        ? {flexBasis: `${featuredBlockWidth}${featureBlockMeasurement}`}
        : featuredBlockWidth > 0
            ? {width: `${featuredBlockWidth}${featureBlockMeasurement}`} : {width: '100%'};
    // console.log(featuredBlockWidthClass)
    const openMenu = useHeaderMenuStore((state) => state.openMenu)

    useEffect(() => {
        const handleMobileMenuClosed = () => megamenuSM.handleMenuClose();
        window.addEventListener("mobile-menu-closed", handleMobileMenuClosed);

        openMenu("MEGAMENU");
        return () => {
            window.removeEventListener("mobile-menu-closed", handleMobileMenuClosed);
        };
    }, [state, id]);

    const { height } = useHeaderHeight();

    return (
        <>
            <MegamenuOverlay settings={settings} type={'darken'}/>
            <nav className={`megamenu-nav megamenu-${layout}`} ref={megamenuRef}>
                <div className={`${settings.section.container_type_inner} relative`}>
                    <div className={`megamenu-nav-area flex`}
                    >
                        <div className={`megamenu-nav-list overflow-y-auto flex bg-white lg:w-[312px] gap-y-[${settings.section.gap_between_text_y}px]
                            ${settings.section.column_width > 0 && `w-[${settings.section.column_width}px]`}
                            ${settings.section.column_spacing != 'none' && settings.section.column_spacing}
                            ${megamenuSM.getPadding(settings.section)}`}
                            style={{
                                height: height,
                            }}
                        >
                            <MegamenuLinks settings={settings} megamenuSM={megamenuSM} level={1} />
                        </div>

                        {

                            (settings.section.show_secondlevel_open_always || megamenuSM.secondLevelLinks?.length > 0) && (
                            <div
                                className={`megamenu-nav-list overflow-y-auto flex bg-white lg:w-[312px] gap-y-[${settings.section.gap_between_text_y}px]
                                ${settings.section.column_width > 0 ? `w-[${settings.section.column_width}px]` : ''}
                                ${settings.section.column_spacing !== 'none' ? settings.section.column_spacing : ''}
                                ${megamenuSM.getPadding(settings.section)}`}
                                style={{
                                    height: height,
                                }}
                            >
                                <MegamenuLinks settings={settings} megamenuSM={megamenuSM} level={2} />
                            </div>
                        )}


                        {megamenuSM.featuredImageBlocks.length > 0 && (<div className={`megamenu-nav-list flex bg-white`}
                            style={featuredBlockWidthClass}
                        >
                            <MegamenuFeaturedImages settings={settings} block={block} megamenuSM={megamenuSM} />
                        </div>)}
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Sidebar;
